// @flow

import createApiClient from 'src/modules/seek-jobs-api-client';
import { trackTabImpression } from 'src/modules/job-tracking';
import { parse as parseCookies } from 'cookie';
import { version } from 'src/config';

export const RESET_FITME = 'RESET_FITME';

const GET_FITME_SUCCESS = 'GET_FITME_SUCCESS';
const GET_FITME_ERROR = 'GET_FITME_ERROR';

type ApiResponse = {
  showTopApplicantBadge: boolean
};

type State = ApiResponse;

type ActionNames = 'GET_FITME_SUCCESS' | 'GET_FITME_ERROR' | 'RESET_FITME';

type Action = {
  type: ActionNames,
  payload: ApiResponse & {
    jobDetailsViewedCorrelationId: string
  }
};

const api = createApiClient();

const initialState = {
  showTopApplicantBadge: false
};

export const tabImpression = () => (dispatch: Function, getState: Function) => {
  const sessionId = parseCookies(document.cookie).JobseekerSessionId;
  const {
    user: { seekerId },
    jobdetails: {
      result: { id }
    },
    fitme: { jobDetailsViewedCorrelationId }
  } = getState();

  trackTabImpression({
    jobId: id,
    candidateId: seekerId,
    sessionId,
    jobDetailsViewedCorrelationId,
    buildVersion: version
  });
};

export default function reducer(state: State = initialState, action: Action) {
  const { showTopApplicantBadge, jobDetailsViewedCorrelationId } =
    action.payload || {};

  switch (action.type) {
    case RESET_FITME:
      return initialState;

    case GET_FITME_SUCCESS:
      return {
        ...state,
        showTopApplicantBadge,
        jobDetailsViewedCorrelationId
      };

    default:
      return state;
  }
}

export const getJobDetailFitMe = ({
  jobId,
  locale,
  sessionId,
  jobDetailsViewedCorrelationId
}: {
  jobId: number,
  locale: Locale,
  sessionId: string,
  jobDetailsViewedCorrelationId: string
}) => (dispatch: Function) => {
  const params = {
    sessionId,
    channel: 'web',
    jobDetailsViewedCorrelationId
  };

  return api.candidate
    .getFitScore({ jobId, params, locale })
    .then(response => {
      return dispatch({
        type: GET_FITME_SUCCESS,
        payload: { ...response, jobDetailsViewedCorrelationId }
      });
    })
    .catch(err => {
      dispatch({
        type: GET_FITME_ERROR,
        payload: err,
        metrics: { name: GET_FITME_ERROR }
      });
    });
};
